import * as types from '../../actions/actiontypes';
import initialState from '../initialstate';
import {
	HttpStatusCodes,
	contactDBRoutes,
	concurrencyErrorCode,
	userDoesNotHavePermissionOnAllEntitiesErrorCode,
	userIsNotEntityAdminOfAllSelectedEntitiesErrorCode,
	userIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes,
	contactHasBeenDeletedErrorCodeCustomAttributes
} from '../../util/uiconstants';
import {currentResource, labels, Errors} from '../../util/utils';

const convertFromString = (string) => {
	const parts = string.split(' - ');
	return {
		Message: parts[1],
		ErrorCode: parts[0]
	};
};

export default function errorReducer(state = initialState.errors, action) {
	switch (action.type) {
		case types.API_ERRORS: {
			if (action.action?.payload?.supressErrorOnUi || action?.supressErrorOnUi) return state;

			if (action.error && action.error.requestUrl) {
				if (action.error.requestUrl.indexOf(contactDBRoutes.entities) > 0) {
					const entityError = action?.error?.response?.data?.errors?.Error || null;
					if (entityError && entityError[0].split(' - ')[0] == concurrencyErrorCode) {
						action.error.response.status = null;
						action.error.response.statusText = null;
					}
				}

				if (action.error.requestUrl.indexOf(contactDBRoutes.contactsDelete) > 0) {
					const entityError = action?.error?.response?.data?.errors?.Error || null;
					if (entityError && entityError[0].split(' - ')[0] == userDoesNotHavePermissionOnAllEntitiesErrorCode) {
						action.error.response.status = null;
						action.error.response.statusText = null;
					}
				}

				if (action.error.requestUrl.indexOf(contactDBRoutes.entities) > 0) {
					const entityError = action?.error?.response?.data?.errors?.Error || null;
					if (entityError && entityError[0].split(' - ')[0] == userIsNotEntityAdminOfAllSelectedEntitiesErrorCode) {
						action.error.response.status = null;
						action.error.response.statusText = null;
					}
				}

				if (action.error.requestUrl.indexOf('/ContactProperties') > 0) {
					const entityError = action?.error?.response?.data?.errors?.Error || null;
					if (
						entityError &&
						entityError[0].split(' - ')[0] == userIsNotEntityAdminOfAllSelectedEntitiesErrorCodeCustomAttributes
					) {
						action.error.response.status = null;
						action.error.response.statusText = null;
					}
				}

				if (action.error.requestUrl.indexOf('/ContactProperties') > 0) {
					const entityError = action?.error?.response?.data?.errors?.Error || null;
					if (entityError && entityError[0].split(' - ')[0] == contactHasBeenDeletedErrorCodeCustomAttributes) {
						action.error.response.status = null;
						action.error.response.statusText = null;
					}
				}
			}

			if (action.error.response) {
				if (action.error.response.data.Errors) {
					return action.error.response.data.Errors;
				} else if (action.error.response.data.errors) {
					if (action.error.response.data.errors.Error) {
						return [...state, convertFromString(action.error.response.data.errors.Error[0])];
					} else if (Object.keys(action.error.response.data.errors).length > 0) {
						let list = [];
						Object.entries(action.error.response.data.errors).forEach((error) => {
							let code = error[1][0].split(' - ')[0];
							let message = error[1][0].split(' - ')[1];

							if (!list.some((item) => item.ErrorCode === code)) {
								list.push({
									ErrorCode: code,
									Message: message
								});
							}
						});

						return _.isEqual(list, state) ? state : list;
					}
				}

				if (action.error.response.data.Message) {
					return [...state, {Message: action.error.response.data.Message}];
				} else {
					return [...state, {Message: action.error.response.statusText}];
				}
			} else {
				return action.error;
			}
		}

		case types.CLIENT_VALIDATION_ERROR:
			return [
				...state,
				{
					Message: action.message,
					level: 'error'
				}
			];

		case types.SUCCESS_MESSAGE:
			return [
				...state,
				{
					Message: action.message,
					level: 'success'
				}
			];

		case types.WARNING_MESSAGE:
			return [
				...state,
				{
					Message: action.message,
					level: 'warning'
				}
			];

		case types.INFO_MESSAGE:
			return [
				...state,
				{
					Message: action.message,
					level: 'info'
				}
			];

		case types.CLEAR_ERRORS:
		case types.CLEAR_ERRORS_SET_MODAL:
			return [];

		case 'DOCHELPER_ERROR':
			const errorObj = action.error;
			switch (errorObj[0]) {
				case HttpStatusCodes.PreConditionFailed:
					return currentResource.DocumentHelper[HttpStatusCodes.PreConditionFailed];
				case HttpStatusCodes.RequestEntityTooLarge:
					return currentResource.DocumentHelper[HttpStatusCodes.RequestEntityTooLarge];
				default:
					return {
						message: `[DocHelper Error][${errorObj[1]}]: ${currentResource.Errors[errorObj[0]] || errorObj[2]}`
					};
			}

		case 'INVALID_RELATED_ENTITY':
			const errorObject = action.error;
			var entityError = '<strong>' + errorObject[0] + ':' + '</strong>';
			return {
				message: `${entityError} ${currentResource.Errors[errorObject[0]]}`
			};

		default:
			return state;
	}
}
